import React from "react";
import { Placeholder } from "@bloomberg/media-ui-article";
import styles from "./wrappedPerformanceChart.module.css";

export function WrappedPerformanceChartPlaceholder() {
  return (
    <div>
      <div className={styles.performanceChartTitle}>Performance Chart</div>
      <div className={styles.performanceChartPlaceholder}>
        <Placeholder.Image />
      </div>
    </div>
  );
}
